import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

import shopperZuluLogo from '../../assets/shopperzulu-logo.png';
import { PRODUCT_BRAND } from '../../config/productBrand';

import css from './ShopperZuluLogo.module.css';

/**
 * @param {'hero'|'mark'} [variant]
 * @param {string|null} [to] — set null for non-link logo
 */
const ShopperZuluLogo = ({ variant = 'mark', className, to = '/landing', alt }) => {
  const img = (
    <img
      src={shopperZuluLogo}
      alt={alt || PRODUCT_BRAND.name}
      className={classNames(
        css.img,
        variant === 'hero' ? css.imgHero : css.imgMark,
        className
      )}
      data-testid="shopperzulu-logo"
    />
  );

  if (to) {
    return (
      <Link to={to} className={css.link} aria-label={PRODUCT_BRAND.name}>
        {img}
      </Link>
    );
  }

  return img;
};

export default ShopperZuluLogo;
